import React from 'react';
import { useQuery } from 'react-apollo';
import { Select } from 'antd';
import gql from 'graphql-tag';

const UNIQUE_EVENT_VENDORS_QUERY = gql`
  query UniqueEventVendors {
    uniqueEventVendors
  }
`;

interface Props {
  value?: string | null;
  onChange: (value: string) => void;
}

function EventVendorFilter(props: Props) {
  const { value, onChange } = props;

  const { loading, data } = useQuery(UNIQUE_EVENT_VENDORS_QUERY);

  return (
    <Select
      value={value || undefined}
      style={{ minWidth: '200px', maxWidth: '500px' }}
      onChange={onChange}
      dropdownMatchSelectWidth={false}
      placeholder={'Select Vendor'}
      maxTagCount={2}
      loading={loading}
      maxTagTextLength={48}
      maxTagPlaceholder={(extraValues) => {
        return <>+&nbsp;{extraValues.length}</>;
      }}
    >
      <Select.Option key="all" value={'all'}>
        {'All Vendors'}
      </Select.Option>

      {!loading &&
        data &&
        data.uniqueEventVendors &&
        data.uniqueEventVendors.map((o, idx) => {
          return (
            <Select.Option key={`${o}_${idx}`} value={o}>
              {o}
            </Select.Option>
          );
        })}
    </Select>
  );
}

export default EventVendorFilter;
